import { render } from "./uploadApproval.vue?vue&type=template&id=66cc9a26&scoped=true"
import script from "./uploadApproval.vue?vue&type=script&lang=js"
export * from "./uploadApproval.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cc9a26"]])

export default __exports__